exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\r\n    display: inline-block;\r\n    margin-left: 0;\r\n    margin-top: 0;\r\n    margin-bottom: 0;\r\n    padding: 0;\r\n    font-size: 26px;\r\n    line-height: 26px;\r\n    color: white;\r\n    cursor: pointer;\r\n    box-sizing: border-box;\r\n    width: 100%;\r\n    height: 80px;\r\n}\r\n\r\nspan {\r\n    pointer-events: none;\r\n}\r\n\r\n.menu-item-text {\r\n    padding-left: 20px;\r\n}\r\n\r\n.menu-item-icon {\r\n    width: 64px;\r\n    height: 64px;\r\n    margin: 8px;\r\n}\r\n\r\n.menu-item {\r\n    display: flex;\r\n    align-items: center;\r\n    height: 77px;\r\n    padding-left: 20px;\r\n}\r\n\r\n    .menu-item:hover {\r\n        background-color: #4eafe4;\r\n    }\r\n\r\n.menu-item-active {\r\n    background-color: #4eafe4;\r\n}\r\n\r\n.menu-item-bottomline {\r\n    height: 2px;\r\n    background-color: #fff;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Scripts/fw/menu/menu-item.component.css
// module id = 2138
// module chunks = 1